import React from "react";
import {
  blackShade19,
  border25,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { Box, Grid, Typography } from "@mui/material";
import InputPreview from "../../../components/Input/InputPreview";

function SelectVariancePreview({ variant1, variant2, view }) {
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>Select Variants</Typography>
      {/* {JSON.stringify(variant1)} */}
      <Grid container rowSpacing={{ xs: 2, md: 2 }} columnSpacing={3}>
        <Grid item xs={8} md={3}>
          <InputPreview
            label="Variant 1"
            value={view ? variant1?.value?.displayName : variant1?.value}
            valueStyles={{ textTransform: "capitalize" }}
            hideBorder
          />
        </Grid>

        <Grid item xs={4} md={9}>
          <InputPreview label="Tags (Min 1)" value={variant1?.tag} hideBorder />
        </Grid>

        {variant2?.value && (
          <>
            <Grid item xs={8} md={3}>
              <InputPreview
                label="Variant 2"
                value={view ? variant2?.value?.displayName : variant2?.value}
                valueStyles={{ textTransform: "capitalize" }}
                hideBorder
              />
            </Grid>

            <Grid item xs={4} md={9}>
              <InputPreview
                label="Tags (Min 1)"
                value={variant2?.tag}
                hideBorder
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
}

export default SelectVariancePreview;

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "15px 15px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "10px",
    color: blackShade19,
  },
};
